import { render, staticRenderFns } from "./LinkWr.vue?vue&type=template&id=6c992b4c&"
import script from "./LinkWr.vue?vue&type=script&lang=js&"
export * from "./LinkWr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports